export type Line = {
  id: string;
  title: string;
  hours: string;
};

export enum DownloadExtension {
  TXT = "txt",
  CSV = "csv",
  PDF = "pdf",
}
